import {BrowserRouter, Routes, Route, Outlet} from "react-router-dom";
import "@/App.css";
import ProtectedRoute from "@/ProtectedRoute";
import SettingsPage from "@/SettingsPage";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import BookingStatus from "@/pages/BookingStatus";
import StaffLogin from "@/pages/StaffLogin";
import Dashboard from "@/pages/Dashboard";
import Cms from "@/pages/Cms";
import {CmsSignIn, CmsSignUp} from "@/pages/CmsAuth";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";

const ClerkLayout = () => <ClerkAuthProvider><Outlet/></ClerkAuthProvider>;

export default function App() {
  return <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home/>}/>
      <Route path="/booking" element={<Booking/>}/>
      <Route path="/booking/status/:code" element={<BookingStatus/>}/>
      <Route path="/staff" element={<StaffLogin/>}/>
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard/></ProtectedRoute>}/>
      <Route path="/dashboard/settings" element={<ProtectedRoute><SettingsPage/></ProtectedRoute>}/>
      <Route element={<ClerkLayout/>}>
        <Route path="/cms" element={<Cms/>}/>
        <Route path="/sign-in/*" element={<CmsSignIn/>}/>
        <Route path="/sign-up/*" element={<CmsSignUp/>}/>
      </Route>
    </Routes>
  </BrowserRouter>;
}
